import { SVGProps } from "react";

const SIHurriyetemlak = (props: SVGProps<SVGSVGElement>) => <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}><title>{"Hurriyetemlak"}</title><path d="M24 16.085L11.994 4.091 0 16.097l3.817 3.812 8.182-8.189 8.189 8.182z" /></svg>;

export { SIHurriyetemlak };